// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Straatbeeld Online Meldingenkaart',
  api_endpoint: 'https://api.straatbeeld.online/',
  latitude: 51.55,
  longitude: 5.083333,
  sentry: {
    dsn: 'https://ae38464c7b0583de4cf9fed47834f530@o4507735602298880.ingest.de.sentry.io/4510221204521040',
    environment: 'production',
    version: version
  }
};
